/* 实拍大图 */
import React from 'react'
import Link from 'next/link'

import getLinkHref from 'lib/get-link-href'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import Image from 'Components/image'

interface IPhoto {
  name: string
  realname: string
  list: [
    {
      toutiaothumburl: string
      id: number
    }
  ]
}

interface IProps {
  seriesId: number
  photosData: any[]
}

export default function Photos({ seriesId, photosData }: IProps) {
  if (!photosData || !photosData.length) {
    return null
  }
  const categoryList = React.useMemo(() => {
    return photosData.map((item: any) => ({
      text: item.realname,
      key: item.name,
    }))
  }, [photosData])

  function renderPhotos(data: IPhoto, which: number) {
    // 当前的图片类型
    const category = categoryList[which]
    return (
      <div key={data.name} className="clearfix line">
        {data.list.slice(0, 4).map((item: IPhoto['list'][0], index: number) => (
          <div
            key={item.toutiaothumburl}
            className="cover fl"
            onClick={() => {
              sendTeaCommEvent('click_series_picture', {
                car_series_id: seriesId,
                sub_tab: category.text,
              })
            }}
          >
            <Link
              href={`/auto/images/detail?category=${category.key}&seriesId=${seriesId}&index=${index}`}
              as={getLinkHref(
                `/auto/series/${seriesId}/images/${category.key}-x-x-${index}`
              )}
            >
              <a target="_blank">
                <Image
                  src={item.toutiaothumburl.replace(/resize:202/, 'resize:400')}
                />
              </a>
            </Link>
          </div>
        ))}
        <style jsx>
          {`
            .line {
              margin-bottom: 16px;
            }
            .line:last-child {
              margin-bottom: 0;
            }
            .cover {
              position: relative;
              overflow: hidden;
              width: 205px;
              height: 137px;
              margin-right: 4px;
            }
            .cover:last-child {
              margin-right: 0;
            }
            .cover:first-child::before {
              content: '${category.text}';
              position: absolute;
              top: 0;
              left: 0;
              z-index: 10;
              width: 55px;
              height: 27px;
              color: #f7f8fc;
              font-size: 14px;
              font-weight: 500;
              border-radius: 1px 0 2px 0;
              line-height: 28px;
              text-align: center;
              background-color: #000000;
            }
          `}
        </style>
      </div>
    )
  }

  return (
    <section>
      <div className="title">
        <div className="links fr">
          <Link
            href={`/auto/images/list?seriesId=${seriesId}`}
            as={getLinkHref(`/auto/series/${seriesId}/images`)}
          >
            <a
              onClick={() => {
                sendTeaCommEvent('click_series_picture_more', {
                  car_series_id: seriesId,
                })
              }}
              target="_blank"
            >
              <div className="more">
                <span>更多</span>
                <span className="icon-arrow-ic-r arrow-right" />
              </div>
            </a>
          </Link>
        </div>
        <h2 className="name" data-module={'实拍大图'}>
          实拍大图
        </h2>
      </div>
      <div className="content">
        {photosData.length
          ? photosData.map((item: IPhoto, index: number) =>
            renderPhotos(item, index)
          )
          : null}
      </div>
      <style jsx>
        {`
          section {
            margin-top: 8px;
            padding: 0 16px;
            width: 868px;
            background: #ffffff;
            border-radius: 2px;
          }
          .title {
            line-height: 53px;
            font-size: 24px;
          }
          .title .name {
            font-size: 18px;
            color: #1f2129;
            letter-spacing: 0;
            font-weight: 500;
          }
          .links .link {
            line-height: 22px;
            padding: 0 12px;
            border-right: 1px solid #e6e6e6;
            font-size: 16px;
            cursor: pointer;
          }
          .content {
            padding-bottom: 16px;
          }
          .more {
            float: right;
            font-size: 12px;
            color: #606370;
            letter-spacing: 0;
            margin-top: 2px;
          }
          .more:hover {
            color: #406599;
          }
          span {
            line-height: 22px;
            padding-left: 12px;
          }
          .arrow-right {
            margin-left: -5px;
            margin-top: -2px;
          }
        `}
      </style>
    </section>
  )
}
